import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { PATHS } from "util/appConstants";
import Navbar from "components/Navbar";
import LightLayout from "components/Shared/LightLayout";
import AdminBar from "components/Masterbar/AdminBar";
import { createSupplier, selectSuppliersStatus } from "redux/slices/supplierSlice";
import { getAllSupplierGroups, selectSupplierGroups } from "redux/slices/supplierGroupsSlice";
import SupplierForm from "components/Suppliers/form";

const currentAction = "ADD";
const AddSupplier = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectSuppliersStatus);
  const supplierGroups = useSelector(selectSupplierGroups);

  useEffect(() => {
    if (!supplierGroups.length && !loading) {
      dispatch(getAllSupplierGroups());
    }
  }, [dispatch, supplierGroups]);

  const onSubmit = async (payload) => {
    await dispatch(createSupplier(payload)).then((res) =>
      res !== undefined ? history.push(PATHS.admin.suppliers) : ""
    );
  };

  return (
    <>
      <Navbar />
      <AdminBar />

      <LightLayout doublebar>
        <SupplierForm action={currentAction} onSubmit={onSubmit} supplierGroups={supplierGroups} />
      </LightLayout>
    </>
  );
};

export default AddSupplier;
